var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPayout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 94,
    height: 60,
    viewBox: "0 0 94 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9012",
    "data-name": "Rectangle 9012",
    width: 94,
    height: 60,
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7844",
    "data-name": "Rectangle 7844",
    width: 37.055,
    height: 43.073,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "integration_tools_-_merchants",
    "data-name": "integration tools - merchants",
    transform: "translate(-165 -429)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "There_are_no_transactions_yet",
    "data-name": "There are no transactions yet",
    transform: "translate(165 429)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32370",
    "data-name": "Group 32370",
    transform: "translate(28.473 8.463)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32369",
    "data-name": "Group 32369",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34564",
    "data-name": "Path 34564",
    d: "M45.294,36.8H40.669a1.305,1.305,0,0,0-1.3,1.3v3.142a1.3,1.3,0,0,0,1.3,1.3h5.2V36.8Z",
    transform: "translate(-8.814 -8.239)",
    fill: "#002c77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34565",
    "data-name": "Path 34565",
    d: "M28.219,35.3v3.135a3.633,3.633,0,0,0,3.632,3.64h3.461v4.16a2.272,2.272,0,0,1-2.274,2.274H2.274A2.272,2.272,0,0,1,0,46.238V24.29A6.664,6.664,0,0,0,4.967,26.5H35.312v5.161H31.859a3.64,3.64,0,0,0-3.64,3.64",
    transform: "translate(0 -5.439)",
    fill: "#3d72fc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7841",
    "data-name": "Rectangle 7841",
    width: 7.156,
    height: 3.221,
    transform: "translate(5.177 15.63)",
    fill: "#5048bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7842",
    "data-name": "Rectangle 7842",
    width: 10.788,
    height: 3.221,
    transform: "translate(23.011 15.63)",
    fill: "#5048bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34566",
    "data-name": "Path 34566",
    d: "M5.238,13.91H12.6v2.716H3.329v4.843A4.018,4.018,0,0,1,5.238,13.91",
    transform: "translate(-0.271 -3.115)",
    fill: "#3d72fc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7843",
    "data-name": "Rectangle 7843",
    width: 9.593,
    height: 2.716,
    transform: "translate(23.011 10.795)",
    fill: "#3d72fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34567",
    "data-name": "Path 34567",
    d: "M27.6,9.049H24.59v9.8H17.023v-9.8h-3L20.811,0Z",
    transform: "translate(-3.139)",
    fill: "#022c77"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayout);
export default __webpack_public_path__ + "static/media/payout.7dd21431b211b5edc682f0afa94d3f77.svg";
export { ForwardRef as ReactComponent };